import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../../../../store/store';
import { Modal } from '../../../../../../components';
import {
  Button,
  ButtonType,
  ButtonVariantType,
} from '../../../../../../components/Button/Button';
import CustomSelect from '../../../../../../components/CustomSelect/CustomSelect';
import { closeIcon, placeholderIcon, teamImg } from './assets';
import { sendSubscription } from '../../../../../../store/org/org.actions';

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

export const ManageSubscriptionModal: React.FC<Props> = ({
  isOpen = false,
  onClose,
}): JSX.Element => {
  const { user } = useSelector((state: RootState) => state.auth);

  const [dropdownValue, setDropdownValue] = useState('');

  const [inputValue, setInputValue] = useState('');

  // const [requestSent, setRequestSent] = useState(false);

  const dispatch = useDispatch();

  const selectValues = [
    { label: 'Manage My Invoices', value: 'sales-force' },
    { label: 'Manage My Subscription', value: 'hub-spot' },
    { label: 'Change Plan', value: 'zoho' },
    { label: 'Update Payment Method', value: 'sales-force' },
  ];

  const changeValue = (newValue: typeof selectValues[0]) =>
    setDropdownValue(newValue.label);

  const changeInputValue = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setInputValue(e.currentTarget.value);
  };

  const isButtonDisabled = !dropdownValue.length;

  const closeAndClear = () => {
    onClose();
    setInputValue('');
    setDropdownValue('');
    // setRequestSent(false);
  };

  const clickSubmit = () => {
    if (user) {
      const { userId, orgId } = user;

      const dataToSend = {
        reason: dropdownValue,
        text: inputValue,
      };

      dispatch(sendSubscription(orgId, userId, dataToSend));
      closeAndClear();
    }
  };

  const attrs = {
    Modal: {
      open: isOpen,
      title: '',
      onClose: closeAndClear,
      // empty: true,
      empty: true,
      noOverlayClose: true,
      className: 'subscription__modal',
    },

    wrapper: {
      className: 'subscription',
    },

    closeIcon: {
      className: 'subscription-close-icon',
      src: closeIcon,
      onClick: closeAndClear,
    },

    title: {
      className: 'subscription-title',
    },

    Select: {
      label: 'Request type',
      placeholder: 'Choose one',
      icon: placeholderIcon,
      medium: true,
      isInSubscription: true,
      items: selectValues,
      onChange: changeValue,
      optionsContainerBackground: '#FFFFFF',
      margin: '40px 0px 0px',
      padding: '0px 12px 0px 0px',
    },

    textarea: {
      wrapper: {
        className: 'subscription__textarea',
        htmlFor: 'sta',
      },

      control: {
        name: 'sta',
        id: 'sta',
        placeholder: 'Tell us more about what you need (optional)',
        className: 'subscription__textarea-control',
        onChange: changeInputValue,
      },
    },

    footer: {
      wrapper: {
        className: 'subscription__footer',
      },

      team: {
        src: teamImg,
        className: 'subscription__footer-img',
      },

      Button: {
        type: 'submit' as ButtonType,
        className: 'subscription__footer-button',
        variant: 'common' as ButtonVariantType,
        disabled: isButtonDisabled,
        onClick: clickSubmit,
      },
    },
  };

  return (
    <Modal {...attrs.Modal}>
      <div {...attrs.wrapper}>
        <img {...attrs.closeIcon} alt="" />
        <div {...attrs.title}>
          Hi {user?.firstName}, how can we help you with your subscription?
        </div>
        <CustomSelect {...attrs.Select} />
        <label {...attrs.textarea.wrapper}>
          <textarea {...attrs.textarea.control} />
        </label>
        <div {...attrs.footer.wrapper}>
          <img {...attrs.footer.team} alt="" />
          <Button {...attrs.footer.Button}>Contact Us</Button>
        </div>
      </div>
    </Modal>
  );
};
